// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"IconLink-module--linkWrapper--2bFB7","link":"IconLink-module--link--1gohe","icon":"IconLink-module--icon--1j34G"};